<template>
  <div>
    <!-- 7 days -->
    <div class="vx-row mb-20">
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Downloads</h3>
        <div class="ml-1 text-gray">Últimos 7 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.downloads_7_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Instalações</h3>
        <div class="ml-1 text-gray">Últimos 7 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.installs_7_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Criou Conta</h3>
        <div class="ml-1 text-gray">Últimos 7 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.signups_7_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Logou no Painel</h3>
        <div class="ml-1 text-gray">Últimos 7 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.logins_7_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <!-- 30 days -->
    <div class="vx-row">
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Downloads</h3>
        <div class="ml-1 text-gray">Últimos 30 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.downloads_30_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Instalações</h3>
        <div class="ml-1 text-gray">Últimos 30 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.installs_30_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Criou Conta</h3>
        <div class="ml-1 text-gray">Últimos 30 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.signups_30_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col md:w-3/12">
        <h3 class="ml-1">Logou no Painel</h3>
        <div class="ml-1 text-gray">Últimos 30 dias</div>
        <vs-table ref="table" noDataText="Nenhum item encontrado" :data="report.logins_30_days" :stripe="true">
          <template slot="thead">
            <vs-th>Data</vs-th>
            <vs-th>Contador</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
              <vs-td>{{ data[idx].dia }}</vs-td>
              <vs-td>{{ data[idx].quantidade }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      report: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.$vs.loading()

      this.$api
      .get('/api/v1/affiliate/report/mobile')
      .then(response => {
        this.$vs.loading.close()
        this.report = response.data
      })
      .catch(() => {
        this.$vs.loading.close()
      })
    }
  }
}
</script>
